module.exports = __webpack_public_path__ + "static/img/SA.df3df5f3.svg";